import { FC, useContext } from "react";
import { useHistory } from "react-router-dom";

import { TeamContext } from "../../../context";
import { MainButton } from "../../atoms";

import dashed from "../../../assets/images/dashed.svg";
import uppinessLogoBlueLetters from "../../../assets/icons/UppinessLogoBlueLetters.png";
import hsaLogo from "../../../assets/images/hsaLogo.png";
import lineDeco from "../../../assets/images/lineDeco.png";

import { useWindowDimensions } from "../../../hooks";
import { useTranslation } from "react-i18next";

const InitialScreenMolecule: FC<{}> = () => {
    const { urlToken } = useContext(TeamContext);
    let history = useHistory();
    let { height } = useWindowDimensions();
    const { t } = useTranslation();

    const startTheGame = () => {
        history.push("/logIn/" + urlToken);
        // socket?.emit("createGame",payload);
    }
 
    return ( 
        <div className="initial_screen_molecule"> 
            <div className="initial_screen_molecule__top_page"> 
                <img className="initial_screen_molecule__line" src={lineDeco} alt="lineDeco" />

                <div className="initial_screen_molecule__center" style={{ width: `${height * 1.5}px`, height: `${height * 0.7}px` }}>
                    <div className="initial_screen_molecule_title_wrapper" style={{ width: "100%", height: "12%", position: "relative" }}>
                        <p className="initial_screen_molecule__center-title " >{t("welcomeText")}</p>
                    </div>
                    <div className="center_horizontally_and_vertically" style={{ width: "100%", height: "60%" }}>
                        <img className="initial_screen_molecule__center__upp_logo" src={uppinessLogoBlueLetters} alt="logo" />
                    </div>
                    <div className="initial_screen_molecule__center__bottom" style={{ width: "100%", height: "28%" }}>
                        <div className="initial_screen_molecule__center__bottom-block">
                            <p className="initial_screen_molecule__center__bottom-block__title">{t("inColabirationText")}</p>
                            <p className="initial_screen_molecule__center__bottom-block__subTitle">{t("drTalBenShahar")}</p>
                            <img className="initial_screen_molecule__center__bottom-block__hsa" src={hsaLogo} alt={hsaLogo} />
                        </div>
                    </div>
                </div>

                <img className="initial_screen_molecule__line" src={lineDeco} alt="lineDeco" />
            </div>

            <div className="initial_screen_molecule__bottom_page">
                <img className="initial_screen_molecule__bottom_page__dashed" src={dashed} alt="dashed" />
                <div className="initial_screen_molecule__bottom_page__button_wrapper center_horizontally_and_vertically">
                    <div className="initial_screen_molecule__bottom_page__button_wrapper__positionin_absolute">
                        <MainButton type="big" text={t("startPlayingText")} clickHandler={() => startTheGame()} />
                    </div>
                </div>
                <img className="initial_screen_molecule__bottom_page__dashed" src={dashed} alt="dashed" />
            </div>
        </div>
    );
}

export default InitialScreenMolecule;
